module.exports = __webpack_public_path__ + "static/media/lorde.0ef58937.png";